export default {
    'View Specific Master Distributor Details':['Listing Master Distributor'],
    'Activate / Deactivate Master Distributor':['Listing Master Distributor'],
    'Flagging Master Distributor Transactions':['Listing Master Distributor'],
    'Edit Master Distributor':['Listing Master Distributor'],
    // 'Listing Sub Distributor': ['Activate / Deactivate Sub Distributor', 'Flagging Sub Distributor Transactions', 'Edit Sub Distributor', 'View Specific Sub Distributor Details']
}

export const dependantRemoverObject = {
    'Listing Master Distributor': ['View Specific Master Distributor Details', 'Flagging Master Distributor Transactions', 'Edit Master Distributor', 'Activate / Deactivate Master Distributor'],
    "View Specific Master Distributor Details": ['Flagging Master Distributor Transactions'],
}